import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import './Classes.css';

const Classes = () => {
  return (
    <section className="classes-section">
      <div className="classes-container">
        
        <div className="classes-content-wrapper">
          <motion.div 
            className="classes-text-box"
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.6 }}
          >
            <h4 className="classes-subtitle">Our Yoga Classes</h4>
            <h2 className="classes-title">Practice with Purpose, Live with Balance</h2>
            <div className="classes-divider"></div>
            
            <p className="classes-desc">
              Explore our diverse range of yoga classes designed to inspire balance, improve flexibility, build strength, and promote inner peace. Whether you're taking your first step into yoga or advancing your practice, our expert-led sessions provide a welcoming space for every individual to grow, heal, and thrive.
            </p>

            <Link to="/appointment" className="btn-book-class">Book a Class</Link>
          </motion.div>

          <motion.div 
            className="classes-image-box"
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <img 
              src="https://images.unsplash.com/photo-1593811167562-9cef47bfc4d7?q=80&w=1200&auto=format&fit=crop" 
              alt="Yoga Classes Group" 
              className="classes-img" 
            />
            <div className="classes-img-outline"></div>
          </motion.div>
        </div>

      </div>
    </section>
  );
};

export default Classes;
